import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Col, Row } from 'react-bootstrap';
import { Frown } from 'react-feather';
import { useEffect, useState } from 'react';

function FeedbackForm(props) {
  let [data, setData] = useState({});

  let alert_questions = [
    'Is the percentage change significant?',
    'Is this a seasonal alert?',
    'Do you want to see changes over time?',
    'Already acted on it in the past?'
  ];
  let rca_questions = [
    'Is the KPI related?',
    'Wish to see more detailed rootcauses?',
    'Does impact value make sense?'
  ];
  let questions = props.type === 'alert' ? alert_questions : rca_questions;

  useEffect(() => {
    setData(props.data);
  }, [props]);

  const onChangeValue = (event) => {
    let feedback = { ...data };
    let bool = event.target.value === 'Yes' ? true : false;
    if (event.target.name.includes('comment'))
      feedback[event.target.name] = event.target.value;
    else feedback[event.target.name] = bool;
    setData(feedback);
  };

  const submitForm = () => {
    if (Object.keys(data).length > 0) props.submitdata(data);
  };

  return (
    <Modal
      {...props}
      //   size="lg"
      aria-labelledby='contained-modal-title-vcenter'
      className='feedbackform'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter' className='d-flex'>
          <Frown className='sad-smile' width='48' height='48' />
          <p className='flex-fill form-title'>
            Sorry that you didn't like the{' '}
            {props.type === 'alert' ? 'alert' : 'rootcause'}. Please provide
            your valuable feedback
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {questions.map((q, i) => {
            return (
              <Row md={12} style={{ padding: '10px 15px', margin: 0 }} key={i}>
                <Col md={8} style={{ float: 'left' }}>
                  {q}
                </Col>
                <Col md={4} style={{ float: 'right', zIndex: 1 }}>
                  <form onChange={onChangeValue}>
                    <label className='fbcontainer'>
                      Yes
                      <input
                        type='radio'
                        name={`question${i + 1}`}
                        value='Yes'
                        readOnly
                        checked={data[`question${i + 1}`]}
                      />
                    </label>
                    <label className='fbcontainer'>
                      No
                      <input
                        type='radio'
                        name={`question${i + 1}`}
                        value='No'
                        readOnly
                        checked={
                          !data[`question${i + 1}`] &&
                          data[`question${i + 1}`] !== null
                        }
                      />
                    </label>
                  </form>
                </Col>
                <Col md={12} className='comment'>
                  <textarea
                    id={`question${i + 1}_comment`}
                    name={`question${i + 1}_comment`}
                    placeholder='Add comments here...'
                    onChange={onChangeValue}
                    defaultValue={data[`question${i + 1}_comment`]}
                  ></textarea>
                </Col>
              </Row>
            );
          })}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={submitForm} className='submit'>
          Submit Feedback
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FeedbackForm;
